<template>
  <el-drawer
    v-model="visible"
    size="540"
    :before-close="handleClose"
    :with-header="false"
    :destroy-on-close="true"
  >
    <!-- :destroy-on-close="true" -->
    <iframe class="iframe-ele" :src="iframeUrl" />
  </el-drawer>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import bus from "vue3-eventbus";

import { getUserSerializeAsToken } from "@/api/biz/user";
import { useChannelStoreHook } from "@/store/modules/channel";
import { useUserStoreHook } from "@/store/modules/user";
import { paramsToQuery } from "@/utils/tool";
const channelStore = useChannelStoreHook();
const userStore = useUserStoreHook();
const visible = ref(false);
const iframeUrl = ref("");

const router = useRouter();

const handleClose = () => {
  visible.value = false;
  iframeUrl.value = "";
  bus.emit("closeJcbBenefitDrawer");
};

const generateUrl = async () => {
  const token = await getUserSerializeAsToken();
  const isDev = ["dev", "192", "localhost"].some(
    key => location.origin.indexOf(key) > -1
  );
  const origin = isDev
    ? "https://dev-m-app-activity.charmdeer.com"
    : "https://m-app-activity.hotelux.com";
  const path = "/activities/hotelux/2026/jcb-Benefit";
  const url = new URL(`${origin}${path}`);
  url.searchParams.set("lang", userStore.language);
  url.searchParams.set("channel", channelStore.channel.key);
  url.searchParams.set("container", "ysysWeb");
  url.searchParams.set("userToken", token);
  url.searchParams.set("origin", location.origin);
  // https://dev-m-app-activity.charmdeer.com/activities/hotelux/jcb-Benefit?lang=jp&channel=hoteluxjp&container=hoteluxapp
  iframeUrl.value = url.href;
};

const handlOnShow = () => {
  visible.value = true;
  generateUrl();
};

const closeAllModal = () => {
  visible.value = false;
};
bus.on("openJcbBenefitDrawer", handlOnShow);
bus.on("closeJcbBenefitDrawer", closeAllModal);
const listenEvent = () => {
  window.addEventListener("message", event => {
    // if (event.origin !== "https://expected-domain.com") return;
    const data = event.data;

    // 根据消息类型处理
    if (data.type === "close") {
      handleClose();
    }
    if (data.type === "openHotel") {
      const query = paramsToQuery();
      handleClose();
      router.push({
        path: "/hotel/detail",
        query: {
          ...query,
          hotelId: data.data
        }
      });
    }
  });
};

onMounted(() => {
  listenEvent();
});

onBeforeUnmount(() => {
  bus.off("openJcbBenefitDrawer", handlOnShow);
  bus.off("closeJcbBenefitDrawer", closeAllModal);
});
</script>

<style lang="scss" scoped>
.iframe-ele {
  width: 100%;
  height: 100%;
}
</style>
